import { useMemo } from 'react';
import { useAppDispatch } from '@store/index';
import {
  setOverlayPanel,
  toggleChat,
  toggleOverlayPanel,
  toggleSidebarExpand,
} from '@features/ui/uiSlice';

export interface ShellActions {
  toggleNav: () => void;
  closeNav: () => void;
  toggleChat: () => void;
}

interface ShellMode {
  /** Rail is a drawer below this width. */
  isMobile: boolean;
  /** Chat has a column of its own rather than floating over the page. */
  chatDocked: boolean;
}

/** A docked panel flips its persisted flag; a floating one takes the overlay slot. */
export function useShellActions({ isMobile, chatDocked }: ShellMode): ShellActions {
  const dispatch = useAppDispatch();

  return useMemo(
    () => ({
      toggleNav: () =>
        dispatch(isMobile ? toggleOverlayPanel('nav') : toggleSidebarExpand()),
      closeNav: () => dispatch(setOverlayPanel(null)),
      toggleChat: () => dispatch(chatDocked ? toggleChat() : toggleOverlayPanel('chat')),
    }),
    [dispatch, isMobile, chatDocked],
  );
}
